import { ReactComponent as SpinWhite } from './ajax-loader-white.svg';
import { ReactComponent as SpinRed } from './ajax-loader-red.svg';
import PropTypes from 'prop-types';

const AccionaSpinner = ({ color = 'red', size = 16 }) => {
  if (color === 'white') {
    return <SpinWhite width={size} height={size} />;
  }
  if (color === 'red') {
    return <SpinRed width={size} height={size} />;
  }
};

AccionaSpinner.propTypes = {
  color: PropTypes.oneOf(['red', 'white']),
  size: PropTypes.number,
};

AccionaSpinner.defaultProps = {
  color: 'red',
  size: 16,
};

export default AccionaSpinner;
